import { useContext } from 'react';
import { Button } from '@givebutter/primitives/button';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as DropdownMenu from 'components/dropdown-menu';
import { TableContext } from 'components/table/TableContext';

const PAGE_SIZES = [20, 40, 60];

interface TablePerPageDropdownProps {
    pageSizes?: number[];
}

const TablePerPageDropdown = (props: TablePerPageDropdownProps) => {
    const { pageSizes = PAGE_SIZES } = props;
    const { table } = useContext(TableContext);

    return (
        <DropdownMenu.Root>
            <DropdownMenu.Trigger asChild={true}>
                <Button size={'sm'} variant="transparent" className={'static right-4 md:absolute'}>
                    <p>{table.getState().pagination.pageSize} per page</p>
                    <FontAwesomeIcon icon={faChevronDown} />
                </Button>
            </DropdownMenu.Trigger>
            <DropdownMenu.Content side={'top'} sideOffset={6} className={'!min-w-[100px]'}>
                {pageSizes.map(pageSize => (
                    <DropdownMenu.Item key={pageSize} onClick={() => table.setPageSize(pageSize)}>
                        {pageSize} per page
                    </DropdownMenu.Item>
                ))}
            </DropdownMenu.Content>
        </DropdownMenu.Root>
    );
};

export { TablePerPageDropdown };
